import { createApiCall } from 'lib/base';

const EDIT_HOME_WIDGET_BANNER = 'EDIT_HOME_WIDGET_BANNER';

const editHomeWidgetBannerApi = createApiCall<{ id: string; payload: any }>(
  EDIT_HOME_WIDGET_BANNER,
  ({ id, payload }) => ({
    endpoint: `api/admin/home-widget-banners/${id}`,
    method: 'PATCH',
    body: payload,
  })
);

export default editHomeWidgetBannerApi;
